import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Registro de Service Worker para Modo Offline
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registrado:', registration);
    }).catch(error => {
      console.log('SW fallo registro:', error);
    });
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min
      gcTime: 24 * 60 * 60 * 1000, // 24h
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Persistencia simple de cache en LocalStorage
const CACHE_KEY = 'sisp_query_cache';
const savedCache = localStorage.getItem(CACHE_KEY);
if (savedCache) {
  try {
    const { state } = JSON.parse(savedCache);
    queryClient.setQueryData([], state);
    // Nota: Esto es muy básico, lo ideal sería hydrate pero sin paquetes extra
    // usaremos la persistencia nativa de react-query si estuviera disponible.
  } catch (e) {}
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
